import { Box } from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import { IconButton } from '@portals/core/src/components/IconButton/IconButton';
import type { IconButtonProps } from '@portals/core/src/components/IconButton/IconButton.types';
import React from 'react';

import { InternIconLink as InternIconLinkModel } from '../../../models';
import { Consumer } from '../../consumers/Consumer/Consumer';
import { useLinkProps } from '../../hooks/useLinkProps';

interface Props {
  node: InternIconLinkModel;
  color?: IconButtonProps['color'];
  circular?: IconButtonProps['circular'];
}

export const InternIconLink: React.FunctionComponent<Props> = ({ node, ...props }: Props) => {
  const { singleProps } = useLinkProps(node?.link[0]);
  const title = node?.link[0]?.title || node?.link[0]?.text || '';

  if (!node) {
    return null;
  }

  return (
    <IconButton key={`icon-${node.id}`} {...singleProps} title={title} {...props}>
      <Box sx={visuallyHidden}>{title}</Box>
      <Consumer node={node.icon} />
    </IconButton>
  );
};
